import { CanActivateFn } from '@angular/router';
import { hasSeparateHosts, isMarketingHost, redirectToQuine } from '../utils/host-url.util';

/**
 * App routes (login, dashboard) belong on the Quine host.
 * Firebase auth is per-origin, so login and dashboard must share a host.
 *
 * Only bounce when hosts are separate AND we're on the marketing host; single-host envs
 * (dev's one site) and unknown hosts (local `ng serve`, preview channels) serve the app directly.
 */
export const quineAppHostGuard: CanActivateFn = (_route, state) => {
  if (typeof window === 'undefined') return true;

  if (hasSeparateHosts() && isMarketingHost()) {
    redirectToQuine(state.url);
    return false;
  }

  return true;
};
